var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('h1',[_vm._v("Coming Soon")]),_c('h3',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Take me home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }